<template>
  <svg width="41" height="40" viewBox="0 0 41 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7603 7.5L16.3632 8.8729C19.1961 10.3671 22.5305 10.3671 25.3634 8.8729L27.9662 7.5L35.8633 11.6654L34.275 15.0163L27.9662 11.6887L26.9516 12.2239C23.1189 14.2455 18.6076 14.2455 14.7749 12.2239L13.7603 11.6887L7.45155 15.0163L5.86328 11.6654L13.7603 7.5Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7603 16.2418L16.3632 17.6147C19.1961 19.1089 22.5305 19.1089 25.3634 17.6147L27.9662 16.2418L35.8633 20.4072L34.275 23.7582L27.9662 20.4305L26.9516 20.9657C23.1189 22.9873 18.6076 22.9873 14.7749 20.9657L13.7603 20.4305L7.45155 23.7582L5.86328 20.4072L13.7603 16.2418Z"
      class="fill-current"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M13.7603 24.9837L16.3632 26.3566C19.1961 27.8508 22.5305 27.8508 25.3634 26.3566L27.9662 24.9837L35.8633 29.149L34.275 32.5L27.9662 29.1724L26.9516 29.7075C23.1189 31.7291 18.6076 31.7291 14.7749 29.7075L13.7603 29.1724L7.45155 32.5L5.86328 29.149L13.7603 24.9837Z"
      class="fill-current"
    />
  </svg>
</template>
